(function () {
  var script = document.getElementById('YflNewsletterPopupGuardScript');
  var newsletterFormId = script && script.dataset.formId;

  if (!newsletterFormId) return;

  var newsletterCopy = [
    'WANT ACCESS TO EXCLUSIVE DEALS?',
    'SIGN ME UP!',
    'THANKS FOR SIGNING UP!',
    'SIGN UP!',
  ];
  var restockCopy = [
    'BACK IN STOCK',
    'NOTIFY ME WHEN AVAILABLE',
    'REQUEST AN AVAILABILITY UPDATE',
  ];
  var closeButtonSelector = [
    'button[aria-label*="close" i]',
    'button[title*="close" i]',
    'button[data-testid*="close" i]',
    'button[class*="close" i]',
    '[role="button"][aria-label*="close" i]',
    'button[aria-label*="stäng" i]',
    'button[aria-label*="schließ" i]',
    'button[aria-label*="fermer" i]',
    'button[aria-label*="cerrar" i]',
    'button[aria-label*="luk" i]',
    'button[aria-label*="sluit" i]',
    'button[aria-label*="chiudi" i]',
    'button[aria-label*="zamkn" i]',
  ].join(',');

  function normalizedText(element) {
    return (element && element.textContent ? element.textContent : '')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function containsAny(text, values) {
    return values.some(function (value) {
      return text.indexOf(value) !== -1;
    });
  }

  function containsNewsletterCopy(text) {
    return newsletterCopy.some(function (value) {
      if (value === 'SIGN UP!') return text === value;
      return text.indexOf(value) !== -1;
    });
  }

  function containsFormId(element) {
    if (!element || !element.getAttribute) return false;

    return ['id', 'class', 'data-form-id', 'data-testid'].some(function (attribute) {
      var value = element.getAttribute(attribute) || '';
      return value.indexOf(newsletterFormId) !== -1;
    });
  }

  function findOverlayRoot(marker) {
    var current = marker;
    var root = marker;

    while (current && current !== document.body) {
      var style = window.getComputedStyle(current);
      var role = current.getAttribute && current.getAttribute('role');
      var isModal = current.getAttribute && current.getAttribute('aria-modal') === 'true';

      if (style.position === 'fixed' || role === 'dialog' || isModal) {
        root = current;
      }

      current = current.parentElement;
    }

    return root;
  }

  function suppressNewsletter(marker) {
    if (
      !marker ||
      marker === document.body ||
      marker === document.documentElement ||
      marker.nodeType !== Node.ELEMENT_NODE
    ) {
      return false;
    }

    var text = normalizedText(marker);
    var isNewsletter = containsFormId(marker) || containsNewsletterCopy(text);

    if (!isNewsletter || containsAny(text, restockCopy)) return false;

    var root = findOverlayRoot(marker);

    if (root.getAttribute('data-yfl-newsletter-popup-suppressed') === 'true') return true;

    var closeButton = root.querySelector(closeButtonSelector);

    root.setAttribute('data-yfl-newsletter-popup-suppressed', 'true');

    // Let Klaviyo run its own close handler first so it can release its state.
    if (closeButton) closeButton.click();

    root.setAttribute('aria-hidden', 'true');
    root.style.setProperty('display', 'none', 'important');
    root.style.setProperty('visibility', 'hidden', 'important');
    root.style.setProperty('pointer-events', 'none', 'important');

    if (window.YflScrollLockSafety) {
      window.YflScrollLockSafety.markRecoveryWindow();
      window.YflScrollLockSafety.scheduleRecovery();
    }

    return true;
  }

  function scan(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return false;

    var candidates = root.querySelectorAll(
      'div, aside, section, [role="dialog"], [aria-modal="true"], [data-form-id]'
    );

    for (var index = candidates.length - 1; index >= 0; index -= 1) {
      if (suppressNewsletter(candidates[index])) return true;
    }

    return suppressNewsletter(root);
  }

  function scanRepeatedly() {
    [0, 50, 250, 1000, 3000].forEach(function (delay) {
      window.setTimeout(function () {
        scan(document.body);
      }, delay);
    });
  }

  window.addEventListener(
    'klaviyoForms',
    function (event) {
      if (
        !event.detail ||
        event.detail.formId !== newsletterFormId ||
        (event.detail.type !== 'open' && event.detail.type !== 'embedOpen')
      ) {
        return;
      }

      scanRepeatedly();
    },
    true
  );

  function startObserver() {
    if (!document.body) return;

    scan(document.body);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
